import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { getName, labelName } from "../../../utils/functions";
import ErrorMessage from "../ErrorrMessage";
import textFieldStyles from "../TextField/TextField.module.css";
import styles from "./Checkbox.module.css";
import Modal from "../../Modal";

export default function CheckBox({ field_label, displayLabel, field_items, parent, isRequired, modalContent=null }) {
  const name = getName(parent, field_label);

  return (
    <>
      <div className={textFieldStyles.inputContainer}>
        <label className={textFieldStyles.label}>{displayLabel || field_label}{isRequired==="true" && <span style={{ color: '#d32f2f', padding: 0 }}>*</span>}</label>
        <div className={styles.checkContainer}>
          {field_items &&
            field_items.length > 0 &&
            field_items.map((item, index) => (
              <CheckBoxInput
                key={`${item}-${index}`}
                title={item}
                name={name}
                parent={parent}
                isRequired={isRequired}
                modalContent={modalContent}
              />
            ))}
        </div>
        <ErrorMessage name={field_label} />
      </div>
      
    </>
  );
}

const CheckBoxInput = ({ title, name, modalContent = null }) => {
  const { setFieldValue, values } = useFormikContext();
  const [showModal, setShow] = useState(false);

  const handleChange = (value, e) => {
    const currentValues = values[name] || [];

    let newValues;

    if (currentValues.includes(value)) {
      newValues = currentValues.filter((item) => item !== value);
    } else {
      newValues = [...currentValues, value];
    }

    setFieldValue(name, newValues);

    if (modalContent && e?.target?.checked === true) {
      setShow(true);
    }
  };

  return (
    <>
      <label className={styles.container}>
        {labelName(title)}
        <input
          type="checkbox"
          value={title}
          name={name}
          checked={values[name]?.includes(title) || false}
          onChange={(e) => handleChange(e.target.value, e)}
        />
        <span className={styles.checkmark}></span>
      </label>

      {modalContent && showModal && (
        <Modal
          isOpen={showModal}
          onClose={() => setShow(false)}
          width="600px"
        >
          {modalContent}
        </Modal>
      )}
    </>
  );
};